export default "__VITE_ASSET__DxygJwuW__"